import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export default function ConfirmationPopup({
  openDelete,
  handleAgree,
  setOpenDelete,
  title,
  reasonField = false,
  reasonLabel = "Reason",
  reasonRequired = false,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [reason, setReason] = React.useState("");

  const handleClose = () => { setReason(""); setOpenDelete(false); };
  const handleConfirm = () => { reasonField ? handleAgree(reason) : handleAgree(); setReason(""); };

  return (
    <Dialog fullScreen={fullScreen} open={openDelete} onClose={handleClose}
      className="mui-confirmation-popup"
      PaperProps={{ sx: { backgroundColor: "#ffffff", border: "1px solid rgba(26,26,26,0.12)", borderRadius: "12px", minWidth: 400 } }}>
      <DialogContent>
        <DialogContentText sx={{ color: "#1a1a1a", fontSize: "14px", fontFamily: "'Rubik', sans-serif" }}>
          {title}
        </DialogContentText>
        {reasonField && (
          <TextField autoFocus fullWidth multiline minRows={2} label={reasonLabel} value={reason}
            onChange={(e) => setReason(e.target.value)} required={reasonRequired}
            sx={{
              mt: 2,
              "& .MuiOutlinedInput-root": {
                color: "#1a1a1a",
                backgroundColor: "#F7F4EF",
                borderRadius: "9px",
                "& fieldset": { borderColor: "rgba(26,26,26,0.16)" },
                "&:hover fieldset": { borderColor: "rgba(26,26,26,0.28)" },
                "&.Mui-focused fieldset": { borderColor: "#c01e2e", borderWidth: "1.5px" },
              },
              "& .MuiInputLabel-root": { color: "#aaa" },
              "& .MuiInputLabel-root.Mui-focused": { color: "#c01e2e" },
            }} />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} sx={{ color: "#6b6b6b", textTransform: "none", fontFamily: "'Rubik', sans-serif" }}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={reasonField && reasonRequired && !reason.trim()}
          sx={{ color: "#c01e2e", textTransform: "none", fontFamily: "'Rubik', sans-serif", "&.Mui-disabled": { color: "rgba(192,30,46,0.4)" } }}>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
}
